
const formats = require('dd-trace/ext/formats');
import Getters from 'data/getters';
import Reactor from 'data/reactor';

import { datadogLogs } from '@datadog/browser-logs';

const pageBasePath = '/nextgen-report';
const environment = process.env.NODE_ENV === 'production' ? process.env.NWEA_ENV : 'team16';


export function logErrorToDatadog(error) {
    console.log("logErrorToDatadog error ::")
    if(!__BATCH__){
        datadogLogs.logger.error('Error occurred', {
            error: error.toString(),
            stack: error.stack || 'No stack trace',
        });
    }
  /* 
    */
}

export function logMessageToDatadog(attribute, details) {
   
    if(!__BATCH__){
        console.log("logMessageToDatadog details ::"+JSON.stringify(details))
        datadogLogs.logger.info(attribute, details);
    }
   // datadogLogs.logger.info(attribute, details);
}

export function sanitizePath(path) {
    let p = pageBasePath + path;
    if (p.indexOf('/students') > -1) {
        p = p.replace(/\/students\/.*/, '/students/profile');
    }
    return p;
}

export function recordPageView(path) {
    const userInfo = Reactor.evaluate(Getters.user.userInfo);
    const partner = userInfo.get('partnerBid');
    const roles = userInfo.get('roles')
        ? userInfo
              .get('roles')
              .toJS()
              .toString()
        : 'UNKNOWN';
    const userBid = userInfo.get('userBid');
    // let roles = Reactor.evaluate(Getters.user.roles);
    ga('set', 'page', path);
    ga('set', 'dimension1', partner);
    ga('set', 'dimension2', roles);
    ga('set', 'dimension3', userBid);
    ga('send', 'pageview');

    logMessageToDatadog('pageView', {
        currentRoute: path,
        partner: partner,
        roles: roles,
        userBid: userBid,
    });
}

/**
 * Record custom event
 * @param {String} action Event description
 * @param {Object} details
 */
export function recordAction(header, action, label = '') {
    if (__UNIT_TEST__) {
        return;
    }
    const userInfo = Reactor.evaluate(Getters.user.userInfo);
    const partner = userInfo.get('partnerBid');
    const roles = userInfo
        .get('roles')
        .toJS()
        .toString();
    const userBid = userInfo.get('userBid');

    ga('send', 'event', header, action, label, {
        dimension1: partner,
        dimension2: roles,
        dimension3: userBid,
    });

    logMessageToDatadog(action, {
        actionName: action,
        header: header,
        label: label,
        partner: partner,
        roles: roles,
        userBid: userBid,
    });
}

/**
 * @param {String} header module button is in
 * @param {String} action
 * @param {String} label
 */
export function recordButtonClick(header, action, label = '') {
    recordAction(header, action, label);
}

/**
 * @param {String} header module button is in
 * @param {String} action
 *
 * Passes in the expanded module ID for label
 */
export function recordButtonClickWithExpandedModuleAsLabel(header, action) {
    const expandedModule = Reactor.evaluate(Getters.runtime.expandedModule);

    recordAction(header, action, expandedModule ? expandedModule : 'default');
}

export default {
    sanitizePath,
    recordPageView,
    recordAction,
    recordButtonClick,
    recordButtonClickWithExpandedModuleAsLabel,
    logErrorToDatadog,
    logMessageToDatadog,
};
